import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';

import { Prospect } from '@gi/models/prospect';
import { ProspectCellComponent } from '@shared-cells/prospect-cell/prospect-cell.component';

@Component({
  selector: 'app-prospect-option',
  standalone: true,
  imports: [ProspectCellComponent],
  templateUrl: './prospect-option.component.html',
  styleUrls: ['./prospect-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tiime-option'
  }
})
export class ProspectOptionComponent {
  readonly prospect: InputSignal<Prospect> = input.required<Prospect>();
}
